enum makeRequest {
    REQUEST = 'REQUEST' 
}

export default makeRequest;